import {
    AfterViewInit,
    Component,
    inject,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PopupService } from './services/popup.service';
import { IPopupComponent } from './interfaces/popup.interface';
import { FormGroup } from '@angular/forms';
import { TranslationService } from '../../../core/services/translate.service';

import {
    TranslateService as NgxTranslateService,
    TranslateService,
} from '@ngx-translate/core';
import { Type } from '../../forms/components/button/types/button-type.type';
import { ConfirmService } from '../confirm/services/confirm.service';
import { Router } from '@angular/router';
import { first, Subscription } from 'rxjs';

@Component({
    selector: 'epmax-popup',
    templateUrl: './popup.component.html',
    styleUrl: './popup.component.scss',
    providers: [],
    standalone: false,
})
export class PopupComponent implements IPopupComponent, OnInit, AfterViewInit {
    public readonly _confirm: ConfirmService = inject(ConfirmService);

    public readonly _translateService: TranslateService =
        inject(TranslateService);

    isfullScreeMode: boolean = false;
    @ViewChild('template', { read: ViewContainerRef }) template!: any;
    instance: any;
    private router = inject(Router);
    options: any;
    constructor(
        private t: TranslationService,
        ngxTranslateService: NgxTranslateService,
        public dialogRef: MatDialogRef<PopupComponent>,
        private popupService: PopupService
    ) {
        this.options = this.popupService.popupOptions;
    }

    subscription!: Subscription;
    popupInstance!: IPopupComponent;

    form!: FormGroup;

    onClose(result?: any) {
        this.popupInstance.onClose();
        this.dialogRef.close(result);
        this.popupService.removeOptions();
    }

    OnAdditionalAction() {
        this.options.status = true;
        // this.popupInstance?.additional?.();
    }

    onButtonHeaderClick() {
        this.popupInstance.onButtonHeaderClick?.();
    }

    public get setOtherButtonsToRight(): boolean {
        return this.options?.setOtherButtonsToRight;
    }
    dismiss(): void {
        if (
            this.popupInstance?.form?.dirty &&
            this.popupInstance?.form?.touched
        ) {
            this._confirm
                .info({
                    subTitle: this._translateService.instant(
                        'Labels.DoYouWantToCloseTheWindow'
                    ),
                    closeButtonText:
                        this._translateService.instant('Buttons.No'),
                    submitButtonText:
                        this._translateService.instant('Buttons.Yes'),
                })
                .subscribe((result) => {
                    if (result) {
                        this.options.status = false;
                        this.onClose();
                    }
                });
        } else {
            this.options.status = false;
            this.onClose();

            //this.fullScreeToggle(true);
        }
    }

    onSubmit(): void {
        
        if (this.popupInstance?.form?.valid || !this.popupInstance?.form) {
            this.options.status = true;
            this.popupInstance.onSubmit();
        } else if (!this.popupInstance?.form?.valid) {
            this.popupInstance?.form?.markAllAsTouched();
            this._confirm
                .info({
                    subTitle: this._translateService.instant(
                        'Validation.FormNotValid'
                    ),
                    closeButtonText:
                        this._translateService.instant('Buttons.Close'),
                })
                .subscribe(() => {});
        }
    }

    createComponent() {
        const temp = this.template.createComponent(
            this.options.externalComponent
        );
        this.popupInstance = temp.instance;
        temp.instance.data = this.options?.data;
        this.popupInstance.popupInstance = this;
        if (this.size == 'fullScreen') {
            this.isfullScreeMode = true;
        }
        this.instance = temp.instance;
    }

    get viewFooter() {
        return (
            !!this.submitButtonText ||
            !!this.closeButtonText ||
            !!this.otherButtons.length
        );
    }

    get otherButtons() {
        return this.instance?.otherButtons || [];
    }

    public get isBusy(): boolean {
        return this.instance?.isBusy;
    }

    public get subTitle(): string {
        return this.options.subTitle;
    }

    public get title(): string {
        return this.options.title;
    }
    public get customStyle(): string {
        return this.options.customStyle +' transition-popup';
    }
    public get size(): string {
        return this.options.size;
    }
    public get submitButtonColor(): Type {
        return this.options.submitButtonColor;
    }

    public get closeButtonColor(): Type {
        return this.options.closeButtonColor;
    }

    public get fullHeight(): string {
        return this.options.fullHeight;
    }

    public get submitButtonText(): string {
        return this.options.submitButtonText;
    }

    public get disableSubmit(): boolean {
        return this.options.disableSubmit;
    }

    public get closeButtonText(): string {
        return this.options.closeButtonText;
    }

    public get buttonHeader(): string {
        return this.options.buttonHeader;
    }

    public get buttonHeaderTitle(): string {
        return this.options.buttonHeaderTitle;
    }


    public get showFullscreenButton(): boolean {
        return this.options.showFullscreenButton != undefined
            ? this.options.showFullscreenButton
            : this.options.size == 'lg';
    }

    public get weight(): number {
        return this.options.weight || 500;
    }
 
    ngAfterViewInit(): void {
         
            this.createComponent();
        [...document.getElementsByClassName("cdk-overlay-popover")].forEach((el) => {

            el?.removeAttribute?.('popover');

        })

         
    }

    ngOnInit(): void {
        this.router.events.pipe(first()).subscribe((res) => {
            this.onClose();
        });
    }

    ngSuperOnDestroy() {}

    fullScreeToggle() {
        this.isfullScreeMode = !this.isfullScreeMode;

        // fromCloseBtn?:boolean as parameter
        // if(fromCloseBtn) {
        //     this.isfullScreeMode = false
        // } else {
        //     this.isfullScreeMode = !this.isfullScreeMode;
        // }

        // if(this.isfullScreeMode) {
        //     this.elem.requestFullscreen?.();
        //     this.elem.mozRequestFullScreen?.();
        //     this.elem.webkitRequestFullscreen?.();
        //     this.elem.msRequestFullscreen?.();
        // } else {
        //     this.document.exitFullscreen?.();
        //     this.document.mozCancelFullScreen?.();
        //     this.document.webkitExitFullscreen?.();
        //     this.document.msExitFullscreen?.();
        // }
    }
}
